import React, { useLayoutEffect, useState } from "react";
import MainTemplate from "@/components/Templates/MainTemplate";
import { PolicyPageContent } from "./AppTemplate";
import { getURLParams } from "@/utils";
import useDisableIntercom from "@/hooks/useDisableIntercom";

function PolicyDesktopTemplate() {
  const [isDesktopWebView, setIsDesktopWebView] = useState(false);

  useDisableIntercom({});
  useLayoutEffect(() => {
    const params = getURLParams();
    const source = params?.get("source") || "";

    if (source?.toLowerCase() !== "app") {
      setIsDesktopWebView(true);
    }
  }, []);

  if (isDesktopWebView) {
    return (
      <MainTemplate>
        <PolicyPageContent showHeader />
      </MainTemplate>
    );
  } else {
    return <PolicyPageContent />;
  }
}

export default PolicyDesktopTemplate;
